import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AnimatedHandModule } from '@app/shared/ui/animated-hand/animated-hand.module';
import { DirectivesModule } from '../directives/directives.module';
import { ProductGradeHandModule } from './product-grade-hand/product-grade-hand.module';
import { ProductGradeModule } from './product-grade/product-grade.module';
import { ProductGradeHorizontalModule } from './product-grade/product-grade-horizontal/product-grade-horizontal.module';
import { ProductGradeHeroModule } from './product-grade/product-grade-hero/product-grade-hero.module';
import { ProductGradeNumberModule } from './product-grade/product-grade-number/product-grade-number.module';
import { ProductGradeTextModule } from './product-grade/product-grade-text/product-grade-text.module';
import { ProductGradeWellModule } from './product-grade/product-grade-well/product-grade-well.module';
import { ProductStickerModule } from './product-sticker/product-sticker.module';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        RouterModule,
        AnimatedHandModule,
        DirectivesModule,
        ProductStickerModule,
        ProductGradeHandModule,
        ProductGradeModule,
        ProductGradeHorizontalModule,
        ProductGradeHeroModule,
        ProductGradeNumberModule,
        ProductGradeTextModule,
        ProductGradeWellModule,
    ],
    exports: [
        ProductStickerModule,
        ProductGradeHandModule,
        ProductGradeModule,
        ProductGradeHorizontalModule,
        ProductGradeHeroModule,
        ProductGradeNumberModule,
        ProductGradeTextModule,
        ProductGradeWellModule,
    ]
})
export class ProductModule {
}
